/* globals window, document */
import React, { Component } from 'react'
import jquery from 'jquery'
import moment from 'moment'

window.jQuery = window.$ = jquery

const $ = window.$

require('semantic-ui/dist/semantic.min.js')
require('semantic-ui/dist/semantic.min.css')
const { calendar } = require('semantic-ui-calendar/dist/calendar')
require('semantic-ui-calendar/dist/calendar.min.css')

class Calendar extends Component {
  componentDidMount() {
    $(this.calendar).calendar({
      onChange: date => {
        this.props.onChange(date)
      },
      disableMinute: true,
      isDisabled: date => {
        const isBeforeToday = moment(date) < moment()
        const isBeforeStartDate = moment(date) < moment(this.props.startDate)
        const isAfterEndDate = moment(date) > moment(this.props.endDate)
        const isStartDate = this.props.selectingType === 'startDate'
        const isEndDate = this.props.selectingType === 'endDate'
        // (isStartDate && isAfterEndDate) ||
        return isEndDate && isBeforeStartDate
      },
    })
    $(this.calendar).calendar(
      'set date',
      console.log('SETTING DATE', this.props.value) || this.props.value,
    )
  }

  render() {
    return (
      <div
        className="ui calendar"
        ref={calendar => {
          this.calendar = calendar
        }}
      >
        <div className="ui input left icon">
          <input type="text" placeholder="Date/Time" />
          <i className="calendar icon" />
        </div>
      </div>
    )
  }
}

export default Calendar



// WEBPACK FOOTER //
// ./src/components/calendar/index.js